import { FC } from "react";

interface HiddenProps {
  if: boolean;
  children: React.JSX.Element;
}

const Hidden: FC<HiddenProps> = (props): React.JSX.Element | null => {
  return (
    <div className={props.if === true ? "" : "hidden"}>{props.children}</div>
  );
};

export default Hidden;
